/**
 * Pure data: manifest names the placeholder atlas resolves by aliasing to a baked base shape.
 * Keeps "every ASSETS name resolves in both atlases" true without drawing 100 placeholder poses.
 * Consumed by buildPlaceholderAtlas() and by tests/assets.test.ts.
 */
import { ASSETS } from '../config.ts';

export const PLACEHOLDER_ALIASES: Record<string, string> = (() => {
  const a: Record<string, string> = {};
  const alias = (names: readonly string[] | string, base: string): void => {
    for (const n of Array.isArray(names) ? names : [names]) a[n] = base;
  };
  alias([ASSETS.pip.idle, ASSETS.pip.walk, ASSETS.pip.skid, ASSETS.pip.fire, ASSETS.pip.bonus, ASSETS.pip.clear, ...ASSETS.pip.dig], 'pip');
  alias(ASSETS.pip.crushed, 'pip.crushed');
  alias([...ASSETS.crawlerState.waddle, ...ASSETS.crawlerState.flatten, ...ASSETS.crawlerState.flamed, ASSETS.crawlerState.flee, ASSETS.crawlerState.stuck], 'crawler');
  alias([...ASSETS.borerState.dig, ASSETS.borerState.eat, ASSETS.borerState.flatten, ASSETS.borerState.flamed, ASSETS.borerState.revert], 'borer');
  for (let i = 0; i < ASSETS.mutationStages; i++) alias(ASSETS.mutation(i), i < 2 ? 'crawler' : 'borer');
  alias([ASSETS.sackState.rest, ...ASSETS.sackState.wobble, ASSETS.sackState.fall, ASSETS.sackState.land, ASSETS.sackState.leanL, ASSETS.sackState.leanR, ASSETS.sackState.burst, ASSETS.sackState.closed], 'sack');
  alias('gold.pile', 'gold');
  alias(ASSETS.tunnel.fill, 'tile.tunnel');
  alias([ASSETS.ui.card, ASSETS.ui.woodSign, ASSETS.ui.tinSign, ASSETS.ui.secondary], 'ui.sign');
  alias([ASSETS.ui.cta, ASSETS.ui.iconRound, ASSETS.ui.toggleOn, ASSETS.ui.toggleOff], ASSETS.brassPlate);
  alias([ASSETS.ui.starEmpty, ASSETS.ui.starFull], 'star');
  alias([ASSETS.scene.surface, ASSETS.scene.shaft], ASSETS.earthMaterial);
  alias([ASSETS.lamp.off, ASSETS.lamp.lit, ASSETS.lamp.next], ASSETS.lanternFill(ASSETS.lanternLevels - 1));
  alias(ASSETS.dangerTag, ASSETS.brassPlate);
  alias(ASSETS.grandpa.content, ASSETS.grandpa.neutral);
  alias(ASSETS.targetPanel, 'ui.sign');
  alias([ASSETS.beam.head, ASSETS.beam.tail], 'flame');
  alias(ASSETS.beam.body, 'glow');
  alias(ASSETS.flameFrames, 'flame');
  alias(ASSETS.turbo.frames, 'pip');
  alias(ASSETS.turbo.burst, 'star');
  alias(ASSETS.kitFruit, 'bonus');
  alias([ASSETS.kit.shield, ASSETS.kit.turbo, ASSETS.kit.beam, ASSETS.kit.fruit, ASSETS.kit.medkit, ASSETS.kit.lock], ASSETS.ui.iconRound);
  alias([ASSETS.raw.hubStage1, ASSETS.raw.hubStage3, ASSETS.raw.hubStage5, ASSETS.raw.museumInterior], ASSETS.earthMaterial);
  alias([ASSETS.raw.museumGems, ASSETS.raw.minigameSigns], 'ui.sign');
  alias(ASSETS.raw.shareCard, 'ui.sign');
  alias(ASSETS.goalIcon('collect'), 'star');
  alias(ASSETS.goalIcon('crush'), 'sack');
  alias(ASSETS.goalIcon('break'), ASSETS.obstacle.pillar[0]);
  alias(ASSETS.goalIcon('survive'), ASSETS.brassPlate);
  alias(ASSETS.goalIcon('clear'), ASSETS.earthMaterial);
  alias(ASSETS.goalIcon('rescue'), 'star');
  alias(ASSETS.grandpa.worried, ASSETS.grandpa.wince);
  return a;
})();
